import { render, staticRenderFns } from "./Title_Article.vue?vue&type=template&id=7de426a2&scoped=true&"
import script from "./Title_Article.vue?vue&type=script&lang=js&"
export * from "./Title_Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de426a2",
  null
  
)

export default component.exports